import React from 'react';
import { TrendingUp, BarChart2, CheckCircle2 } from 'lucide-react';

export const AnalyticsBIModule: React.FC = () => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-cyan-100 text-cyan-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            PowerBI & Tableau Health Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Executive Analytics & BI Reporting</h2>
          <p className="text-xs text-slate-500">Cross-departmental IEP compliance gauges, therapist utilization charts, and outcome trends</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-4 bg-cyan-50/50 border border-cyan-200 rounded-xl">
          <div className="text-xs text-slate-500 font-bold">Overall IEP Compliance Rate</div>
          <div className="text-3xl font-black text-cyan-700 mt-1">98.4%</div>
          <div className="text-[10px] text-emerald-600 font-bold mt-1">↑ +4.2% vs previous quarter</div>
        </div>

        <div className="p-4 bg-blue-50/50 border border-blue-200 rounded-xl">
          <div className="text-xs text-slate-500 font-bold">Therapist Utilization Rate</div>
          <div className="text-3xl font-black text-blue-700 mt-1">91.2%</div>
          <div className="text-[10px] text-blue-600 font-bold mt-1">Optimal Clinical Capacity</div>
        </div>

        <div className="p-4 bg-emerald-50/50 border border-emerald-200 rounded-xl">
          <div className="text-xs text-slate-500 font-bold">Goal Completion Index</div>
          <div className="text-3xl font-black text-emerald-700 mt-1">87.9%</div>
          <div className="text-[10px] text-emerald-600 font-bold mt-1">1,420 Goals Mastered</div>
        </div>
      </div>
    </div>
  );
};
